import React from 'react';
import './Toggle.scss';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  id?: string;
}

const Toggle: React.FC<ToggleProps> = ({ 
  checked, 
  onChange, 
  disabled = false,
  label,
  id 
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <div className="toggle">
      {label && (
        <label htmlFor={id} className="toggle__label">
          {label}
        </label>
      )}
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        className={`toggle__switch ${checked ? 'toggle__switch--checked' : ''} ${disabled ? 'toggle__switch--disabled' : ''}`}
        onClick={handleToggle}
        disabled={disabled}
        aria-label={label || 'Toggle'}
      >
        <span className="toggle__slider" />
      </button>
    </div>
  );
};

export default Toggle;

